import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import WhopPixel from "./components/WhopPixel";

const NotFound = lazy(() => import("./pages/NotFound.tsx"));
const FooterPages = () => null;
const FeaturesPage = lazy(() => import("./pages/FooterPages").then(m => ({ default: m.FeaturesPage })));
const PricingPage = lazy(() => import("./pages/FooterPages").then(m => ({ default: m.PricingPage })));
const IntegrationsPage = lazy(() => import("./pages/FooterPages").then(m => ({ default: m.IntegrationsPage })));
const AboutPage = lazy(() => import("./pages/FooterPages").then(m => ({ default: m.AboutPage })));
const CustomersPage = lazy(() => import("./pages/FooterPages").then(m => ({ default: m.CustomersPage })));
const ContactPage = lazy(() => import("./pages/FooterPages").then(m => ({ default: m.ContactPage })));
const HelpCenterPage = lazy(() => import("./pages/FooterPages").then(m => ({ default: m.HelpCenterPage })));
const ApiDocsPage = lazy(() => import("./pages/ApiDocs"));
const PrivacyPage = lazy(() => import("./pages/FooterPages").then(m => ({ default: m.PrivacyPage })));
const TermsPage = lazy(() => import("./pages/FooterPages").then(m => ({ default: m.TermsPage })));
const FeatureSubPage = lazy(() => import("./pages/SubPages").then(m => ({ default: m.FeatureSubPage })));
const IndustrySubPage = lazy(() => import("./pages/SubPages").then(m => ({ default: m.IndustrySubPage })));
const IntegrationSubPage = lazy(() => import("./pages/SubPages").then(m => ({ default: m.IntegrationSubPage })));
const IndustriesIndex = lazy(() => import("./pages/SubPages").then(m => ({ default: m.IndustriesIndex })));
const Videos = lazy(() => import("./pages/Videos"));
const VideoWatch = lazy(() => import("./pages/VideoWatch"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <WhopPixel />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/integrations" element={<IntegrationsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/help" element={<HelpCenterPage />} />
            <Route path="/api-docs" element={<ApiDocsPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/privacy.html" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/features/:slug" element={<FeatureSubPage />} />
            <Route path="/integrations/:slug" element={<IntegrationSubPage />} />
            <Route path="/industries" element={<IndustriesIndex />} />
            <Route path="/industries/:slug" element={<IndustrySubPage />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/videos/:slug" element={<VideoWatch />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
